import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-700cf511"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Download ")
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "maengel-sidebar-wrapper" }
const _hoisted_4 = { class: "sidebar-heading w-full p-4" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "subtitle flex-1",
  style: {"margin-top":"0","margin-bottom":"0"}
}, " Mängelliste ", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Synchronisieren ")
const _hoisted_8 = { class: "flex mt-2 items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "checkbox" }, "Zeige nur offene Mängel", -1))
const _hoisted_10 = { class: "scrollbar pt-4" }
const _hoisted_11 = { class: "px-4" }
const _hoisted_12 = { class: "mangel-row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Freitext ", -1))
const _hoisted_14 = { class: "content" }
const _hoisted_15 = { class: "mangel-row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Relevant ", -1))
const _hoisted_17 = { class: "content" }
const _hoisted_18 = { class: "mangel-row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Handlungsbedarf - Tätigkeit ", -1))
const _hoisted_20 = { class: "content" }
const _hoisted_21 = { class: "mangel-row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Handlungsbedarf - Zeitpunkt ", -1))
const _hoisted_23 = { class: "content" }
const _hoisted_24 = { class: "mangel-row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Kategorie ", -1))
const _hoisted_26 = { class: "content" }
const _hoisted_27 = { class: "mangel-row" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Bilder ", -1))
const _hoisted_29 = { class: "content" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Tag hinzufügen ")
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Tag löschen ")
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  id: "showcase",
  class: "iframe",
  frameborder: "0",
  allowFullScreen: "",
  allow: "xr-spatial-tracking",
  width: "100%",
  height: "1000px"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_hzba_group = _resolveComponent("hzba-group")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_Toolbar, {
        title: "Matterport Tags",
        "show-back-button": "",
        onOnBackButtonClicked: _cache[1] || (_cache[1] = () => {})
      }, {
        leading: _withCtx(() => [
          _createVNode(_component_ion_buttons, { slot: "start" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_button, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace(_ctx.goBackUrl)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    slot: "icon-only",
                    icon: _ctx.arrowBack
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        trailing: _withCtx(() => [
          _createVNode(_component_ion_buttons, { slot: "primary" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_button, {
                slot: "end",
                color: "light",
                onClick: _ctx.downloadPdf
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createVNode(_component_ion_button, {
                      color: "light",
                      size: "small",
                      onClick: $setup.syncBestandsaufnahme
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      id: "checkbox",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.showOnlyUnfinished) = $event)),
                      type: "checkbox",
                      class: "mr-2"
                    }, null, 512), [
                      [_vModelCheckbox, $setup.showOnlyUnfinished]
                    ]),
                    _hoisted_9
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.maengel, (mangel) => {
                    return _withDirectives((_openBlock(), _createBlock(_component_hzba_group, {
                      key: mangel,
                      "hide-progress": "",
                      title: `${mangel.titel()} (${mangel.maluspunkte() } MP)`,
                      class: "mangel-item mb-4",
                      "outer-margin": false,
                      "smaller-title": ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("div", _hoisted_14, _toDisplayString(mangel.freitext), 1)
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createElementVNode("div", _hoisted_17, _toDisplayString(mangel.relevant ? 'Ja' : 'Nein'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _hoisted_19,
                            _createElementVNode("div", _hoisted_20, _toDisplayString(mangel.vorlage.handlungsbedarfTaetigkeit), 1)
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _hoisted_22,
                            _createElementVNode("div", _hoisted_23, _toDisplayString(mangel.vorlage.handlungsbedarfZeitpunkt), 1)
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _createElementVNode("div", _hoisted_26, _toDisplayString(mangel.vorlage.kategorie), 1)
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _hoisted_28,
                            _createElementVNode("div", _hoisted_29, [
                              (!mangel.bilder || mangel.bilder.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, " - "))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mangel.bilder, (bild, key) => {
                                return (_openBlock(), _createElementBlock("img", {
                                  key: key,
                                  src: $setup.getPhotoUrl(bild),
                                  width: "64",
                                  height: "64",
                                  class: "object-cover mr-2"
                                }, null, 8, _hoisted_31))
                              }), 128))
                            ])
                          ]),
                          (!(mangel.tag3d && mangel.tag3d))
                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                key: 0,
                                onClick: ($event: any) => ($setup.addMangelTag(mangel))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_32
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true),
                          (mangel.tag3d)
                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                key: 1,
                                fill: "flat",
                                onClick: ($event: any) => ($setup.removeMangelTag(mangel))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_33
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["title"])), [
                      [_vShow, !$setup.showOnlyUnfinished || !mangel.tag3d]
                    ])
                  }), 128))
                ])
              ]),
              _hoisted_34
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}